"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchChats = void 0;
const react_1 = require("react");
const useLatestAsyncEffect_1 = require("./useLatestAsyncEffect");
const context_1 = require("../context");
const utils_1 = require("../utils");
const ApiHandler_1 = require("../utils/ApiHandler");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
const useFetchChats = (chatId, groupType) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const { setChat, setIsChatLoading, setIsChatDeleted, chat } = (0, react_1.useContext)(context_1.ChatContext);
    const [fetchChatError, setFetchChatError] = (0, react_1.useState)();
    (0, useLatestAsyncEffect_1.useLatestAsyncEffect)((checkIfLatest, abortContext) => __awaiter(void 0, void 0, void 0, function* () {
        if (!chatId)
            return;
        const chatManagerGroupType = selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getChatManagerForGroupType(groupType);
        try {
            setFetchChatError(undefined);
            setIsChatDeleted(false);
            if (!chatManagerGroupType)
                throw new Error("Chat Manager not found in Right Panel");
            chatManagerGroupType.getStoredChat(chatId);
            // Always set the chat synchronously from storage
            setChat(chatManagerGroupType.touchChat(chatId));
            setIsChatLoading(true);
            yield chatManagerGroupType.getFreshChat(chatId, abortContext);
            // After fetching the latest chat info, set the chat again if this effect is still the latest
            if (checkIfLatest()) {
                setChat(chatManagerGroupType.getChat(chatId));
            }
            setIsChatLoading(false);
        }
        catch (e) {
            if (checkIfLatest()) {
                setFetchChatError(e);
                if ((0, ApiHandler_1.isChatDeletedError)(e))
                    setIsChatDeleted(true);
            }
        }
    }), [chatId, selectedOrgUser, groupType], () => {
        setChat(undefined);
    });
    const openChat = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext, chat) => __awaiter(void 0, void 0, void 0, function* () {
        yield chat.openChat(abortContext);
    }), utils_1.Constants.API_DEBOUNCE_DELAY_IN_MS);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!chat)
                return;
            try {
                yield openChat(chat);
            }
            catch (e) {
                // The backend keeps serving group info for a deleted chat and only
                // refuses its messages, so this is where a deletion usually surfaces.
                // Every other failure here stays silent, as it was before this catch
                // existed — routing it to fetchChatError would start bouncing users out
                // of a chat whose messages merely failed to load.
                if ((0, ApiHandler_1.isChatDeletedError)(e)) {
                    setFetchChatError(e);
                    setIsChatDeleted(true);
                }
            }
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chat === null || chat === void 0 ? void 0 : chat.chatInfo.id]);
    return {
        fetchChatError,
    };
};
exports.useFetchChats = useFetchChats;
